import Immutable from 'immutable';

import ErrorData from 'sharedreact/data/ErrorData';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

type OnFetchSuccess = (
  what: string,
  start: number,
  end: number,
  items: Immutable.List<any>,
  fetchInfo: Immutable.Map<string, any>) => void;

type OnFetchMoreSuccess = (
  what: string,
  fetchId: string,
  start: number,
  end: number,
  startRecord: number,
  items: Immutable.List<any>,
  fetchInfo: Immutable.Map<string, any>) => void;

type OnError = (what: string, error: ErrorData) => void;

function fetch (
  what: string,
  start: number,
  end: number,
  maxSamples: number,
  onSuccess: OnFetchSuccess,
  onError: OnError
) {
  ConnectionSupport.post(
    'getLoadHistory',
    {
      what: what,
      maxSamples: maxSamples,
      start: start,
      end: end
    },
    (data) => {
      onSuccess(
        what,
        start,
        end,
        Immutable.List((data).slice(1).map((str: any) => { return JSON.parse(str); })),
        Immutable.fromJS(JSON.parse(data[0]))
      );
    },
    (error) => onError(what, error)
  );
}

function fetchMore (
  what: string,
  fetchId: string,
  start: number,
  end: number,
  startRecord: number,
  sampleInterval: number,
  onSuccess: OnFetchMoreSuccess,
  onError: OnError
) {
  ConnectionSupport.post(
    'getLoadHistory',
    {
      what: what,
      start: start,
      end: end,
      startRecord: startRecord,
      sampleInterval: sampleInterval
    },
    (data) => {
      onSuccess(
        what,
        fetchId,
        start,
        end,
        startRecord, 
        Immutable.List((data).slice(1).map((str: any)  => { return JSON.parse(str); })),
        Immutable.fromJS(JSON.parse(data[0]))
      );
    },
    (error) => onError(what, error)
  );
}
const LoadHistoryConnection = {
  fetch,
  fetchMore
};

export default LoadHistoryConnection;